var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidsManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_13771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4978 15.9362C1.98089 14.6883 1.71484 13.3508 1.71484 12.0001C1.71484 10.6493 1.98089 9.31182 2.4978 8.0639C3.0147 6.81598 3.77234 5.68209 4.72746 4.72697C5.68258 3.77185 6.81647 3.01421 8.06439 2.49731C9.31231 1.9804 10.6498 1.71436 12.0006 1.71436C13.3513 1.71436 14.6888 1.9804 15.9367 2.49731C17.1847 3.01421 18.3185 3.77185 19.2737 4.72697C20.2288 5.68209 20.9864 6.81598 21.5033 8.0639C22.0202 9.31182 22.2863 10.6493 22.2863 12.0001C22.2863 13.3508 22.0202 14.6883 21.5033 15.9362C20.9864 17.1842 20.2288 18.3181 19.2737 19.2732C18.3185 20.2283 17.1847 20.9859 15.9367 21.5028C14.6888 22.0197 13.3513 22.2858 12.0006 22.2858C10.6498 22.2858 9.31231 22.0197 8.06439 21.5028C6.81647 20.9859 5.68258 20.2283 4.72746 19.2732C3.77234 18.3181 3.0147 17.1842 2.4978 15.9362Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57031 16.7144C8.57031 16.7144 9.42746 18.4286 11.9989 18.4286C14.5703 18.4286 15.4275 16.7144 15.4275 16.7144",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14342 13.2856C7.90672 13.2856 7.71484 13.0937 7.71484 12.857C7.71484 12.6203 7.90672 12.4285 8.14342 12.4285",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14453 13.2856C8.38122 13.2856 8.5731 13.0937 8.5731 12.857C8.5731 12.6203 8.38122 12.4285 8.14453 12.4285",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8583 13.2856C15.6216 13.2856 15.4297 13.0937 15.4297 12.857C15.4297 12.6203 15.6216 12.4285 15.8583 12.4285",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8594 13.2856C16.0961 13.2856 16.2879 13.0937 16.2879 12.857C16.2879 12.6203 16.0961 12.4285 15.8594 12.4285",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 1.71436C11.144 2.28578 9.42969 3.94293 9.42969 6.00007C9.42969 8.5715 12.8583 9.42864 13.7154 6.85721",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_13771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsManagement);
export default __webpack_public_path__ + "static/media/kids_management.5d429c9d207351e264cb1cbf0cc5f454.svg";
export { ForwardRef as ReactComponent };